/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportCostsByDayRollup
 */
export interface ReportCostsByDayRollup {
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByDayRollup
     */
    employees: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByDayRollup
     */
    shifts: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByDayRollup
     */
    hoursScheduled: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByDayRollup
     */
    hoursWorked: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByDayRollup
     */
    costsScheduled: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByDayRollup
     */
    costsWorked: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByDayRollup
     */
    icrTouchNetSales: number;
}

/**
 * Check if a given object implements the ReportCostsByDayRollup interface.
 */
export function instanceOfReportCostsByDayRollup(value: object): value is ReportCostsByDayRollup {
    if (!('employees' in value) || value['employees'] === undefined) return false;
    if (!('shifts' in value) || value['shifts'] === undefined) return false;
    if (!('hoursScheduled' in value) || value['hoursScheduled'] === undefined) return false;
    if (!('hoursWorked' in value) || value['hoursWorked'] === undefined) return false;
    if (!('costsScheduled' in value) || value['costsScheduled'] === undefined) return false;
    if (!('costsWorked' in value) || value['costsWorked'] === undefined) return false;
    if (!('icrTouchNetSales' in value) || value['icrTouchNetSales'] === undefined) return false;
    return true;
}

export function ReportCostsByDayRollupFromJSON(json: any): ReportCostsByDayRollup {
    return ReportCostsByDayRollupFromJSONTyped(json, false);
}

export function ReportCostsByDayRollupFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportCostsByDayRollup {
    if (json == null) {
        return json;
    }
    return {
        
        'employees': json['employees'],
        'shifts': json['shifts'],
        'hoursScheduled': json['hoursScheduled'],
        'hoursWorked': json['hoursWorked'],
        'costsScheduled': json['costsScheduled'],
        'costsWorked': json['costsWorked'],
        'icrTouchNetSales': json['icrTouchNetSales'],
    };
}

  export function ReportCostsByDayRollupToJSON(json: any): ReportCostsByDayRollup {
      return ReportCostsByDayRollupToJSONTyped(json, false);
  }

  export function ReportCostsByDayRollupToJSONTyped(value?: ReportCostsByDayRollup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employees': value['employees'],
        'shifts': value['shifts'],
        'hoursScheduled': value['hoursScheduled'],
        'hoursWorked': value['hoursWorked'],
        'costsScheduled': value['costsScheduled'],
        'costsWorked': value['costsWorked'],
        'icrTouchNetSales': value['icrTouchNetSales'],
    };
}

